import { Consolidation } from '@returnmates/client-core/src/graphql/generated/api'
import { RETURNMATES_URL } from '@returnmates/ui-core/src/constants/paths'
import moment from 'moment'

import {
  CONTAINER_ZPL_LABEL_IMAGE_DPI_203,
  CONTAINER_ZPL_LABEL_IMAGE_DPI_300,
  PRINT_LABEL_SIZE_OPTIONS,
  ZPL_TEMAPLTE_IMAGE,
} from '../constants'

interface Props {
  consolidation: Consolidation
}

const containerLabelDpi300 = ({ consolidation }: Props) => `
^XA

^FX Fourth section (the two boxes on the bottom).
^FO0,0^GB1218,1827,60^FS

^FO440,1200 
^BQN,2,10
^FDQA,${JSON.stringify({ container_id: consolidation.id })}
^FS

^CF0,150
^FWB^FO150,150^FD${consolidation.hubOriginSortCode}^FS

^CF0,435
^FWB^FO480,270^FD${consolidation.hubDestinationSortCode}^FS

^CF0,60
^FWB^FO1012,360^FD${consolidation.id}^FS
${CONTAINER_ZPL_LABEL_IMAGE_DPI_300}
^XZ`

const containerLabelDpi203 = ({ consolidation }: Props) => `
^XA

^FX Fourth section (the two boxes on the bottom).
^FO0,0^GB812,1218,40^FS

^FO240,730
^BQN,2,10
^FDQA,${JSON.stringify({ container_id: consolidation.id })}
^FS

^CF0,100
^FWB^FO100,100^FD${consolidation.hubOriginSortCode}^FS

^CF0,290
^FWB^FO320,180^FD${consolidation.hubDestinationSortCode}^FS

^CF0,40
^FWB^FO675,240^FD${consolidation.id}^FS
${CONTAINER_ZPL_LABEL_IMAGE_DPI_203}
^XZ`

const rmLabelDpi300 = ({ consolidation }: Props, formattedID: string, qrCodeUrl: string) => `
^XA
^LH10,10
^LS0
^MTD
^PW1200
^FX Pickup Details
^FWN,0
^CF0,60
^FO20,50
^FD${consolidation.partner.name}
^FS
^CF0,40
^FO20,133
^FD${consolidation.address.name}
^FS
^FO20,192
^FD${consolidation.address.street} ${consolidation.address.unit ? consolidation.address.unit : ''}
^FS^FO20,251
^FD${consolidation.address.city}, ${consolidation.address.state} ${consolidation.address.zipCode}
^FS
^FO20,325
^GB1141,4,4
^FS
^FO20,384
^FDCARRIER: ${consolidation.carrier?.name ? consolidation.carrier?.name : '-'}
^FS
^FO20,473
^FDCREATED: ${moment.unix(consolidation.createdAt).format('MM-DD-yyyy')}
^FS
^FO20,562
^FDDEPARTURE DATE: ${consolidation.expectedDeliveryDate ? consolidation.expectedDeliveryDate : '-'}
^FS
^FO20,1330
^FDID: ${consolidation.id}
^FS^FO20,1389
^BY3,2,120
^BC,,N
^FD${formattedID}
^FS
^FO900,700
^BQN,2,6
^FDQA,${qrCodeUrl}
^FS
^FO700,1650
^GFA,5600,5600,56,${ZPL_TEMAPLTE_IMAGE}
^FS
^XZ`

const rmLabelDpi203 = ({ consolidation }: Props, formattedID: string, qrCodeUrl: string) => `
^XA
^LH10,10
^LS0
^MTD
^PW812
^FX Pickup Details
^FWN,0
^CF0,40
^FO20,30
^FD${consolidation.partner.name}
^FS
^CF0,30
^FO20,90
^FD${consolidation.address.name}
^FS
^FO20,130
^FD${consolidation.address.street} ${consolidation.address.unit ? consolidation.address.unit : ''}
^FS^FO20,170
^FD${consolidation.address.city}, ${consolidation.address.state} ${consolidation.address.zipCode}
^FS
^FO20,220
^GB812,3,3
^FS
^FO20,260
^FDCARRIER: ${consolidation.carrier?.name ? consolidation.carrier?.name : '-'}
^FS
^FO20,320
^FDCREATED: ${moment.unix(consolidation.createdAt).format('MM-DD-yyyy')}
^FS
^FO20,380
^FDDEPARTURE DATE: ${consolidation.expectedDeliveryDate ? consolidation.expectedDeliveryDate : '-'}
^FS
^FO20,890
^FDID: ${consolidation.id}
^FS^FO20,930
^BY2,2,80
^BC,,N
^FD${formattedID}
^FS
^FO600,470
^BQN,2,4
^FDQA,${qrCodeUrl}
^FS
^FO200,1070
^GFA,5600,5600,56,${ZPL_TEMAPLTE_IMAGE}
^FS
^XZ`

export const getRMLabel = (
  { consolidation }: Props,
  printLabelSize: typeof PRINT_LABEL_SIZE_OPTIONS[keyof typeof PRINT_LABEL_SIZE_OPTIONS],
): string => {
  const formattedID = consolidation.id.split('-').join('')
  const qrCodeUrl = `${RETURNMATES_URL}/consolidation/${consolidation.id}`

  let rmLabel
  switch (printLabelSize) {
    case PRINT_LABEL_SIZE_OPTIONS.dpi203:
      rmLabel = rmLabelDpi203({ consolidation }, formattedID, qrCodeUrl)
      break
    case PRINT_LABEL_SIZE_OPTIONS.dpi300:
      rmLabel = rmLabelDpi300({ consolidation }, formattedID, qrCodeUrl)
      break
    default:
      rmLabel = rmLabelDpi203({ consolidation }, formattedID, qrCodeUrl)
  }

  return rmLabel
}

export const getContainerLabel = (
  { consolidation }: Props,
  printLabelSize: typeof PRINT_LABEL_SIZE_OPTIONS[keyof typeof PRINT_LABEL_SIZE_OPTIONS],
): string => {
  let containerLabel
  switch (printLabelSize) {
    case PRINT_LABEL_SIZE_OPTIONS.dpi203:
      containerLabel = containerLabelDpi203({ consolidation })
      break
    case PRINT_LABEL_SIZE_OPTIONS.dpi300:
      containerLabel = containerLabelDpi300({ consolidation })
      break
    default:
      containerLabel = containerLabelDpi203({ consolidation })
  }

  return containerLabel
}
